import React from 'react';
import './SquareIcon.scss';

function SquareIcon() {

	return (
		<img className="square-icon" alt="square icon" src="/logo192.png"/>
	);
}

export default SquareIcon;
